export default __webpack_public_path__ + "static/media/reacher_s2_004.25a7fa41.jpg";